import * as React from "react";
import "./MainStudentPage.sass"
import {useDispatch, useSelector} from "react-redux";
import InformationBlock from "../../_containers/infoblock/InformationBlock";
import StudentGrid from "../../_components/student/StudentGrid";
import {ADDRESS} from "../../_api/client";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import moment from "moment/moment";
import {useEffect} from "react";
import {getNextLesson} from "../../_actions/auth/authService";

export default function MainStudentPage() {
    const {firstName, lastName, courses, img, lesson} = useSelector(state => state.auth.current)
    const dispatch = useDispatch();

    useEffect(() => {
        if (!lesson) {
            dispatch(getNextLesson())
        }
    }, [lesson, dispatch])
    useEffect(() => {
        document.title = 'КьюАй - Профиль'
    }, [])

    return (
        <div className="MainStudentPage-wrapper">
            <InformationBlock>
                <div className="MainStudentPage-info-block">
                    <div className="MainStudentPage-info-img-block">
                        <div className="MainStudentPage-info-img">
                            {img
                                ? <img src={`${ADDRESS}/avatar/${img}`} alt={`${lastName} ${firstName}`} />
                                : <img src={`${ADDRESS}/images/release/tmp/student-img.png`} alt={`${lastName} ${firstName}`}/>}
                        </div>
                    </div>
                    <div className="MainStudentPage-info-main">
                        <div className="MainStudentPage-info-name-panel">
                            <div className="MainStudentPage-info-name">
                                {`${lastName} ${firstName}`}
                            </div>
                        </div>
                        <div className="MainStudentPage-info-user">
                            <div className="MainStudentPage-info-user-item">
                                <SchoolOutlinedIcon/>
                                <div>
                                    <b>Курсы:</b>
                                    <div>{courses && courses.map(course => course.name).join(", ")}</div>
                                </div>
                            </div>
                            <div className="MainStudentPage-info-user-item">
                                <AccessTimeOutlinedIcon/>
                                <div>
                                    <b>Следующий урок:</b>
                                    <div className="MainTeacherPage-info-user-lesson">
                                        {lesson && moment(`${lesson.date} ${lesson.time}`, "YYYY-MM-DD HH:mm:SS").calendar()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </InformationBlock>
            <StudentGrid/>
        </div>
    )
}